import { http } from '@/core/api/';

export default {
  getCurrentAcademicYear() {
    return http.get('/api/academicyears/current');
  },
  async getHRrequestAcademicYears(minYear) {
    if(minYear == undefined)
      minYear = 2021;
    const { data } = await http.get(
      `/api/academicyears/academicyearfromintotype?minYear=${minYear}&yearType=FUTURE`
    );
    return data;
  },
  getRegions(selectedAcademicYear) {
    return http.get(
      `api/schools/user/regions?academicyear=${selectedAcademicYear.id}`
    );
  },
  getSampleInventoryStatuses() {
    return http.get(`api/code/getallsampleinventorystatuses`);
  },
  getDistricts(selectedRegion, selectedAcademicYear) {
    return http.get(
      `api/schools/user/districts?regionid=${selectedRegion.id}&academicyear=${selectedAcademicYear.id}`
    );
  },
  getSchools(selectedDistrict, selectedAcademicYear) {
    return http.get(
      `api/schools/user/schools?districtid=${selectedDistrict.id}&academicyear=${selectedAcademicYear.id}`
    );
  },
  getEduEsp(properties) {
    return http.get('api/code/geteduespcodes', {
      params: { ...properties },
    });
  },
  getGrades(properties) {
    return http.get('api/books/grades', {
      params: { ...properties },
    });
  },
  getSaloonType() {
    return http.get('api/code/me/saloon');
  },
  getStatusList() {
    return http.get('api/code/materialsequipmentstatus');
  },
  getFiscalYears() {
    return http.get('api/sampleinventory/fiscalyears');
  },
};

export const getAcademicYearsToType = (yearType = 'CURRENT', minYear = 2018) => http.get(
    `api/academicyears/academicyearfromintotype?yearType=${yearType}&minYear=${minYear}`
  );
